var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// ファイルアップロードのテンプレート
import React, { useState, memo } from 'react';
import { Form, Col, Row, InputGroup, Button } from 'react-bootstrap';
import axios from '../axios';
import Compressor from 'compressorjs';
import { pdf_icon, compressor_option, file_type_error, file_upload_error, file_upload_clamp_config, download_wait_time, } from '../Const';
import FileSelect from '../molecules/FileSelect';
import RowTemplate from '../atoms/RowTemplate';
import ModalTemplate from '../molecules/ModalTemplate';
import ValidMessage from '../atoms/ValidMessage';
import { convertLine } from '../Convert';
import Canvas from '../molecules/Canvas';
import NextButton from '../molecules/DefaultButton';
import { isBrowserIOSSafari, isBrowserIpadSafari } from '../BrowserJudgment';
import { releaseBrowzerBack } from '../BrowzerBack';
import LoadingModal from './LoadingModal';
var FileUpload = function (_a) {
    var files_upload = _a.files_upload, setFilesUpload = _a.setFilesUpload, files_upload_info = _a.files_upload_info, block_disabled = _a.block_disabled, handleNextButtonClick = _a.handleNextButtonClick, next_button_disabled = _a.next_button_disabled, file_upload_message = _a.file_upload_message, t = _a.t;
    var _b = useState(false), is_processing = _b[0], setIsProcessing = _b[1];
    // ローディング画面表示状態
    var _c = useState(false), is_loading = _c[0], setIsLoading = _c[1];
    /**
     * Postするformデータを作成
     * @param file_upload ファイルアップロード
     * @param files_upload_info　ファイルアップロード情報
     */
    var createFormData = function (file_upload, files_upload_info) {
        var form = new FormData();
        var shelf_cd = file_upload.shelf_cd;
        form.append('file', file_upload.file);
        form.append('file_path', file_upload.file_upload_name);
        form.append('document_cd', file_upload.default_value);
        form.append('ident_lv1_cd', files_upload_info.reception.ident_lv1_cd);
        form.append('ident_lv2_cd', files_upload_info.reception.ident_lv2_cd);
        form.append('ident_lv3_cd', files_upload_info.reception.ident_lv3_cd);
        form.append('reception_id', files_upload_info.reception.reception_id.toString());
        form.append('reception_cd', files_upload_info.reception.reception_cd);
        form.append('reception_sub_cd', files_upload_info.reception.reception_sub_cd);
        form.append('shelf_cd', shelf_cd);
        return form;
    };
    /**
     * バリデーションメッセージの作成
     * @param errors エラーメッセージ
     * @param file_upload ファイルアップロード
     * @param can_file_clear 読み込みファイルの削除フラグ
     */
    var makeValidMessage = function (errors, file_upload, can_file_clear) {
        var result = {};
        Object.keys(errors).forEach(function (key) {
            result[key] = errors[key][0];
        });
        setFilesUpload(function (prev) {
            return prev.map(function (value) {
                return value.name === file_upload.name
                    ? __assign(__assign({}, file_upload), { preview_file_src: can_file_clear ? '' : file_upload.preview_file_src, file_label: can_file_clear ? '' : file_upload.file_label, file: can_file_clear ? new Blob() : file_upload.file, is_loading: false, loading_msg: '', valid_messages: result }) : value;
            });
        });
    };
    /**
     * ファイルアップロードのイベントセレクタ
     * @param file_upload ファイルアップロード
     * @param upload_image アップロード対象画像ファイル
     */
    var handleUpload = function (file_upload, upload_image) { return __awaiter(void 0, void 0, void 0, function () {
        var edit_file_upload, response_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    //アップロード対象の画像ファイルがない場合は処理を行わない
                    if (!upload_image) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    // 処理中フラグを有効にする。
                    setIsProcessing(true);
                    setFilesUpload(function (prev) {
                        return prev.map(function (value) {
                            return value.name === file_upload.name
                                ? __assign(__assign({}, file_upload), { is_loading: true, loading_msg: '少々お待ちください...', valid_messages: {} }) : value;
                        });
                    });
                    edit_file_upload = editFileUpload(file_upload, files_upload, upload_image);
                    return [4 /*yield*/, axios.post('/api/file', createFormData(edit_file_upload, files_upload_info))];
                case 2:
                    response_1 = _a.sent();
                    setFilesUpload(function (prev) {
                        return prev.map(function (value) {
                            return value.name === file_upload.name
                                ? __assign(__assign({}, file_upload), { is_loading: false, loading_msg: response_1.data.summary, is_uploaded: true, file_upload_date: response_1.data.file_upload_date, file_upload_name: response_1.data.file_name, file_status: response_1.data.file_status }) : value;
                        });
                    });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    // バリデーション検知時
                    if (error_1.response.status !== undefined &&
                        error_1.response.status !== null &&
                        error_1.response.status === 422) {
                        makeValidMessage(error_1.response.data.errors, file_upload, false);
                    }
                    else {
                        // ローディング画像非表示
                        setFilesUpload(function (prev) {
                            return prev.map(function (value) {
                                return value.name === file_upload.name
                                    ? __assign(__assign({}, file_upload), { is_loading: false, loading_msg: 'ファイルアップロードに失敗しました' }) : value;
                            });
                        });
                        // ログ出力
                        console.error(error_1);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    // 処理中フラグを無効にする。
                    setIsProcessing(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    /**
     * アップロード追加ボタン押下のイベントハンドラ
     * @param file_upload ファイルアップロード
     */
    var handleAdd = function (file_upload) {
        var _a;
        // 処理中フラグを有効にする。
        setIsProcessing(true);
        //押下された追加ボタンの次に追加する要素が来るようfiles_uploadを分割する。
        var marge_files_upload = new Array();
        //追加対象の棚種別と一致するfile_uploadをfiles_uploadから抽出する。
        var add_file_upload_list = files_upload.filter(function (value) {
            return value.shelf_cd === file_upload.shelf_cd;
        });
        //追加対象の棚種別のfile_upload.nameの配列
        var file_upload_target_name_list = add_file_upload_list.map(function (item) {
            return item.name;
        });
        //file_upload.nameの配列
        var file_upload_name_list = files_upload.map(function (item) {
            return item.name;
        });
        // 追加対象の棚種別の中でfiles_uploadの中で最後尾となる位置を設定する。
        var target_name = file_upload_name_list.indexOf(Math.max.apply(Math, file_upload_target_name_list));
        var new_file_upload = {
            name: target_name > 0 ? target_name : file_upload_name_list.length + 1,
            title: file_upload.title,
            default_value: (_a = file_upload.source[0].key) !== null && _a !== void 0 ? _a : '',
            shelf_cd: file_upload.shelf_cd,
            source: file_upload.source,
            preview_file_src: '',
            file_label: '',
            is_loading: false,
            loading_msg: '',
            is_add: false,
            is_staff: file_upload.is_staff,
            is_uploaded: false,
            file_upload_date: '',
            confirm_date: '',
            confirm_user: '',
            file: new Blob(),
            valid_messages: {},
            is_modal_show: false,
            file_upload_name: '',
            file_status: '',
            is_pdf: false,
        };
        files_upload.map(function (item, index) {
            //nameはtarget_nameの分を空けて設定する。
            var result = __assign(__assign({}, item), { name: index < target_name ? index : index + 1 });
            marge_files_upload.push(result);
            if (index === target_name) {
                marge_files_upload.push(new_file_upload);
            }
        });
        // 既存ファイルアップロードの下に項目追加
        setFilesUpload(marge_files_upload);
        // 処理中フラグを無効にする。
        setIsProcessing(false);
    };
    /**
     * 削除ボタン押下時のイベントハンドラ
     * @param file_upload ファイルアップロード
     */
    var handleDelete = function (file_upload) {
        // 処理中フラグを有効にする。
        setIsProcessing(true);
        setFilesUpload(function (prev) { return prev.filter(function (value) { return value.name !== file_upload.name; }); });
        // 処理中フラグを削除にする。
        setIsProcessing(false);
    };
    /**
     * ファイル選択時のイベントハンドラ
     */
    var handleFileSelect = function (file_upload, event) {
        // event.persist();
        var event_value = event.target.value;
        setFilesUpload(function (prev) {
            return prev.map(function (value) {
                return value.name === file_upload.name ? __assign(__assign({}, file_upload), { default_value: event_value }) : value;
            });
        });
    };
    /**
     * ファイルインプットのイベントハンドラ
     * @param file_upload ファイルアップロード
     * @param event イベント
     */
    var handleFileInput = function (file_upload, event) {
        if (event.target.files === null) {
            return;
        }
        var file = event.target.files[0];
        // ファイルの指定がない場合は処理しない
        if (file === null) {
            return;
        }
        // 処理中フラグを有効にする。
        setIsProcessing(true);
        if (file.type.match('image.*') || file.type.match('.*pdf')) {
            //画像ファイルはそのまま,PDFファイルは代用アイコンを画面表示する。
            fileRender(file_upload, file, file.name);
        }
        else if (file.name.toLowerCase().match(/[.]heic$/)) {
            // heicファイルはJPEGに変換する
            convertHeicToWebImage(file_upload, file);
        }
        else {
            //画像,pdf以外のファイルの場合はバリデーションメッセージを表示する。
            makeValidMessage(file_type_error, file_upload, true);
        }
        // イベント対象の値を初期化
        event.target.value = '';
        // 処理中フラグを無効にする。
        setIsProcessing(false);
    };
    /**
     * ファイルダウンロード
     * @param file_download ダウンロードするファイル
     */
    var handlefileDownLoad = function (file_download) {
        //処理中の場合は処理を中断する。
        if (is_processing) {
            return false;
        }
        //IOS端末かつsafariの場合、ブラウザバック禁止処理を解除してダウンロードしたファイルを表示後に元画面に戻れるようにする。
        if (isBrowserIOSSafari() || isBrowserIpadSafari()) {
            releaseBrowzerBack();
        }
        try {
            // ローディング画面を表示する。
            setIsLoading(true);
            // 処理中フラグを有効にする。
            setIsProcessing(true);
            //ファイルをダウンロードする。
            var url = process.env.MIX_MOCK_URL + "/api/file/download/" + file_download;
            var self_download_link = document.createElement('a');
            document.body.appendChild(self_download_link);
            self_download_link.download = "" + file_download;
            self_download_link.href = url;
            self_download_link.click();
            self_download_link.remove();
            URL.revokeObjectURL(url);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            // 処理中フラグを無効にする。
            setIsProcessing(false);
            // ローディング停止を遅らせる
            setTimeout(function () {
                setIsLoading(false);
            }, download_wait_time);
        }
    };
    var compressorImage = function (file_upload) {
        var file = file_upload.file;
        if (!file) {
            handleConfirmTmp(file_upload);
        }
        // pdfファイルの場合圧縮を行わずにアップロードを行う
        else if (file.type === 'application/pdf' &&
            file_upload.is_uploaded !== null &&
            file_upload.is_uploaded) {
            handleConfirmTmp(file_upload);
        }
        else if (file.type === 'application/pdf' && !file_upload.is_uploaded) {
            handleUpload(file_upload, file_upload.file);
        }
        else {
            //pdfファイル以外でファイルが存在する場合
            var compress_image_1 = new Image();
            compress_image_1.src = file_upload.preview_file_src;
            compress_image_1.onload = function () {
                if (compress_image_1.naturalWidth <= compressor_option.max_width &&
                    compress_image_1.naturalHeight <= compressor_option.max_height) {
                    //アップロード済みの場合は書類確認,そうでない場合はファイルアップロードを行う
                    if (file_upload.is_uploaded !== null && file_upload.is_uploaded) {
                        handleConfirm(file_upload, file);
                    }
                    else {
                        handleUpload(file_upload, file);
                    }
                }
                else {
                    //画像ファイルを圧縮する。縦幅か横幅のどちらかが定数指定の最大サイズを超えた場合は最大サイズに合わせて縮小する。
                    new Compressor(file, {
                        quality: compressor_option.quality,
                        maxHeight: compressor_option.max_height,
                        maxWidth: compressor_option.max_width,
                        mimeType: file.type,
                        success: function (compressor_image) {
                            //アップロード済みの場合は書類確認,そうでない場合はファイルアップロードを行う
                            if (file_upload.is_uploaded !== null && file_upload.is_uploaded) {
                                handleConfirm(file_upload, compressor_image);
                            }
                            else {
                                handleUpload(file_upload, compressor_image);
                            }
                        },
                        //画像圧縮に失敗した場合はメッセージを表示
                        error: function (error) {
                            console.log(error);
                            makeValidMessage(file_upload_error, file_upload, true);
                        },
                    });
                }
            };
        }
    };
    //読み込んだ画像を画面描画する。
    var fileRender = function (file_upload, file, file_name) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setFilesUpload(function (prev) {
                return prev.map(function (value) {
                    return value.name === file_upload.name
                        ? __assign(__assign({}, file_upload), { 
                            //pdfの場合,代用のアイコンを表示
                            preview_file_src: file.type === 'application/pdf' ? pdf_icon : reader.result, file_label: file_name, file: file, file_status: '', loading_msg: '', valid_messages: {}, is_pdf: file.type === 'application/pdf' }) : value;
                });
            });
        };
    };
    /**
     * HEIF or HEICファイルをWeb利用可能な画像フォーマットに変換する
     * @param file_upload ファイルアップロード
     * @param file ファイル(Blob)
     */
    var convertHeicToWebImage = function (file_upload, file) {
        var convert = function (file) { return __awaiter(void 0, void 0, void 0, function () {
            var fd, headers, response_2, bin, buffer, i, blob_1, exception_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // ローディング表示をする
                        setFilesUpload(function (prev) {
                            return prev.map(function (value) {
                                return value.name === file_upload.name
                                    ? __assign(__assign({}, file_upload), { preview_file_src: '', file_label: '', file: new Blob(), loading_msg: '画像を読み込んでいます。', is_loading: true, valid_messages: {} }) : value;
                            });
                        });
                        fd = new FormData();
                        fd.append('image', file);
                        headers = { 'content-type': 'multipart/form-data' };
                        return [4 /*yield*/, axios.post('/api/file/convert_heic', fd, { headers: headers })];
                    case 1:
                        response_2 = _a.sent();
                        // ファイルの読み込みに失敗した場合
                        if (!response_2.data.result) {
                            setFilesUpload(function (prev) {
                                return prev.map(function (value) {
                                    return value.name === file_upload.name
                                        ? __assign(__assign({}, file_upload), { preview_file_src: '', file_label: '', file: new Blob(), loading_msg: '', is_loading: false, valid_messages: {} }) : value;
                                });
                            });
                            throw 'ファイルの読み込みに失敗しました。';
                        }
                        bin = atob(response_2.data.image);
                        buffer = new Uint8Array(bin.length);
                        for (i = 0; i < bin.length; i++) {
                            buffer[i] = bin.charCodeAt(i);
                        }
                        blob_1 = new Blob([buffer.buffer], {
                            type: response_2.data.mime_type,
                        });
                        // 変換後の画像を画面に表示する
                        setFilesUpload(function (prev) {
                            return prev.map(function (value) {
                                return value.name === file_upload.name
                                    ? __assign(__assign({}, file_upload), { preview_file_src: response_2.data.data_scheme + response_2.data.image, file_label: response_2.data.original_name, file: blob_1, loading_msg: '', is_loading: false, valid_messages: {} }) : value;
                            });
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        exception_1 = _a.sent();
                        console.error(exception_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        convert(file);
    };
    /**
     * モーダルの表示制御
     * @param file_upload ファイルアップロード
     * @param modal_show_flg モーダル表示非表示フラグ
     */
    var modalControl = function (file_upload, modal_show_flg) {
        setFilesUpload(function (prev) {
            return prev.map(function (value) {
                return value.name === file_upload.name
                    ? __assign(__assign({}, file_upload), { is_modal_show: modal_show_flg }) : value;
            });
        });
    };
    /**
     * 削除ボタン押下時のイベントハンドラ
     * @param file_upload ファイルアップロード
     */
    var handleCancel = function (file_upload) { return __awaiter(void 0, void 0, void 0, function () {
        var url, request_param, response_3, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // 処理中フラグを有効にする。
                    setIsProcessing(true);
                    setFilesUpload(function (prev) {
                        return prev.map(function (value) {
                            return value.name === file_upload.name
                                ? __assign(__assign({}, file_upload), { is_loading: true, loading_msg: '少々お待ちください...', is_modal_show: false }) : value;
                        });
                    });
                    url = "/api/file/" + file_upload.name;
                    request_param = __assign(__assign({}, files_upload_info.reception), { document_cd: file_upload.default_value, file_path: file_upload.file_upload_name });
                    return [4 /*yield*/, axios.delete(url, {
                            params: request_param,
                        })];
                case 1:
                    response_3 = _a.sent();
                    setFilesUpload(function (prev) {
                        return prev.map(function (value) {
                            return value.name === file_upload.name
                                ? __assign(__assign({}, file_upload), { file_status: response_3.data.file_status, preview_file_src: '', file_label: '', is_loading: false, loading_msg: response_3.data.summary, is_uploaded: false, file_upload_date: '', file: new Blob(), is_modal_show: false, file_upload_name: '' }) : value;
                        });
                    });
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 4];
                case 3:
                    // 処理中フラグを無効にする。
                    setIsProcessing(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * 確認ボタン押下時のイベントハンドラ(暫定)
     * @param file_upload ファイルアップロード
     */
    var handleConfirmTmp = function (file_upload) { return __awaiter(void 0, void 0, void 0, function () {
        var url, form, shelf_cd, response_4, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // 処理中フラグを有効にする。
                    setIsProcessing(true);
                    setFilesUpload(function (prev) {
                        return prev.map(function (value) {
                            return value.name === file_upload.name
                                ? __assign(__assign({}, file_upload), { is_loading: true, loading_msg: '少々お待ちください...' }) : value;
                        });
                    });
                    url = "/api/file/" + file_upload.name;
                    form = new FormData();
                    shelf_cd = file_upload.shelf_cd;
                    form.append('file_path', file_upload.file_upload_name);
                    form.append('document_cd', file_upload.default_value);
                    form.append('ident_lv1_cd', files_upload_info.reception.ident_lv1_cd);
                    form.append('ident_lv2_cd', files_upload_info.reception.ident_lv2_cd);
                    form.append('ident_lv3_cd', files_upload_info.reception.ident_lv3_cd);
                    form.append('reception_id', files_upload_info.reception.reception_id.toString());
                    form.append('reception_cd', files_upload_info.reception.reception_cd);
                    form.append('reception_sub_cd', files_upload_info.reception.reception_sub_cd);
                    form.append('shelf_cd', shelf_cd);
                    return [4 /*yield*/, axios.post(url, form, {
                            // ↓ headersを追記
                            headers: {
                                'X-HTTP-Method-Override': 'PUT',
                            },
                        })];
                case 1:
                    response_4 = _a.sent();
                    setFilesUpload(function (prev) {
                        return prev.map(function (value) {
                            return value.name === file_upload.name
                                ? __assign(__assign({}, file_upload), { is_loading: false, confirm_date: response_4.data.confirm_date, confirm_user: response_4.data.confirm_user, loading_msg: response_4.data.summary, file_status: response_4.data.file_status }) : value;
                        });
                    });
                    return [3 /*break*/, 4];
                case 2:
                    error_3 = _a.sent();
                    console.error(error_3);
                    return [3 /*break*/, 4];
                case 3:
                    // 処理中フラグを無効にする。
                    setIsProcessing(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * 確認ボタン押下時のイベントハンドラ
     * @param file_upload ファイルアップロード
     */
    var handleConfirm = function (file_upload, upload_image) { return __awaiter(void 0, void 0, void 0, function () {
        var edit_file_upload_1, url, response_5, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // 処理中フラグを有効にする。
                    setIsProcessing(true);
                    setFilesUpload(function (prev) {
                        return prev.map(function (value) {
                            return value.name === file_upload.name
                                ? __assign(__assign({}, file_upload), { is_loading: true, loading_msg: '少々お待ちください...' }) : value;
                        });
                    });
                    edit_file_upload_1 = editFileUpload(file_upload, files_upload, upload_image);
                    url = "/api/file/" + edit_file_upload_1.name;
                    return [4 /*yield*/, axios.post(url, createFormData(edit_file_upload_1, files_upload_info), {
                            // ↓ headersを追記
                            headers: {
                                'X-HTTP-Method-Override': 'PUT',
                            },
                        })];
                case 1:
                    response_5 = _a.sent();
                    setFilesUpload(function (prev) {
                        return prev.map(function (value) {
                            return value.name === edit_file_upload_1.name
                                ? __assign(__assign({}, edit_file_upload_1), { is_loading: false, confirm_date: response_5.data.confirm_date, confirm_user: response_5.data.confirm_user, loading_msg: response_5.data.summary, file_status: response_5.data.file_status }) : value;
                        });
                    });
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _a.sent();
                    console.error(error_4);
                    return [3 /*break*/, 4];
                case 3:
                    // 処理中フラグを無効にする。
                    setIsProcessing(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * 確認取消ボタン押下時のイベントハンドラ
     * @param file_upload ファイルアップロード
     */
    var handleConfirmCancel = function (file_upload) { return __awaiter(void 0, void 0, void 0, function () {
        var url, request_param, response_6, error_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    // 処理中フラグを有効にする。
                    setIsProcessing(true);
                    setFilesUpload(function (prev) {
                        return prev.map(function (value) {
                            return value.name === file_upload.name
                                ? __assign(__assign({}, file_upload), { is_loading: true, loading_msg: '少々お待ちください...' }) : value;
                        });
                    });
                    url = "/api/file/" + file_upload.name + "/edit";
                    request_param = __assign(__assign({}, files_upload_info.reception), { document_cd: file_upload.default_value, file_path: file_upload.file_upload_name });
                    return [4 /*yield*/, axios.get(url, {
                            params: request_param,
                        })];
                case 1:
                    response_6 = _a.sent();
                    setFilesUpload(function (prev) {
                        return prev.map(function (value) {
                            return value.name === file_upload.name
                                ? __assign(__assign({}, file_upload), { is_loading: false, confirm_date: '', confirm_user: '', file_status: response_6.data.file_status, loading_msg: response_6.data.summary }) : value;
                        });
                    });
                    return [3 /*break*/, 4];
                case 2:
                    error_5 = _a.sent();
                    console.error(error_5);
                    return [3 /*break*/, 4];
                case 3:
                    // 処理中フラグを有効にする。
                    setIsProcessing(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * マスキング完了処理
     *
     * @param {string} file_src データURL
     * @param {FileUploadType} file_upload
     * @returns void
     */
    var handleMaskingFinish = function (file_src, file_upload) {
        //取得したプレビュー画像を読み込み
        var new_image = new Image();
        new_image.src = file_src;
        //画像を読み込み後にcanvasタグを生成し,プレビュー画像を描画してblobを取得する。
        new_image.onload = function () {
            var canvas_image = document.createElement('canvas');
            canvas_image.width = new_image.naturalWidth;
            canvas_image.height = new_image.naturalHeight;
            var context = canvas_image.getContext('2d');
            if (context !== null) {
                context.imageSmoothingEnabled = false;
                context.drawImage(new_image, 0, 0);
                // 画像データを更新
                canvas_image.toBlob(function (blob) {
                    if (blob !== null) {
                        setFilesUpload(function (prev) {
                            return prev.map(function (value) {
                                return value.name === file_upload.name
                                    ? __assign(__assign({}, file_upload), { preview_file_src: file_src, file: blob, is_loading: false, loading_msg: '' }) : value;
                            });
                        });
                    }
                });
            }
        };
    };
    /**
     * リクエストパラメータ(file_upload)の編集を行う
     * @param file_upload ファイルアップロード情報
     * @param fileｓ_upload ファイルアップロード情報の配列
     * @param fileｓ_upload アップロード用の画像ファイル
     * @return FileUploadType 編集済みのファイルアップロード情報
     */
    var editFileUpload = function (file_upload, files_upload, upload_image) {
        var result_file_upload = file_upload;
        //file_uploadにアップロード対象の圧縮済みまたはpdf形式の画像ファイルを設定する。
        files_upload.map(function (value) {
            if (value.name === file_upload.name) {
                //file_uploadに圧縮済みの画像またはpdfファイルを設定する。
                result_file_upload = __assign(__assign({}, value), { file: upload_image });
            }
        });
        return result_file_upload;
    };
    /**
     * クランプ文字を付与する
     * @param value 文字列
     * @param is_uploaded アップロード済みフラグ
     * @return string 処理後の文字列
     */
    var addClamp = function (value, is_uploaded) {
        if (value !== null &&
            typeof value !== 'undefined' &&
            is_uploaded &&
            value.length >= file_upload_clamp_config.length) {
            var str = value.substring(0, file_upload_clamp_config.length);
            return "" + str + file_upload_clamp_config.clamp_string;
        }
        return value;
    };
    /**
     * ローディングを開始する
     * @param file_upload ファイルアップロード
     */
    var startLoading = function (file_upload, msg) {
        setFilesUpload(function (prev) {
            return prev.map(function (value) {
                return value.name === file_upload.name
                    ? __assign(__assign({}, file_upload), { is_loading: true, loading_msg: msg }) : value;
            });
        });
    };
    /**
     * 「銀行へ提出」ボタンのdisabled判定
     *
     * @param {FileUploadType} file_upload ファイル用オブジェクト
     * @return {boolean} 判定結果(disabledならtrue)
     */
    var disabedSubmit = function (file_upload) {
        return (file_upload.is_loading ||
            file_upload.is_uploaded ||
            file_upload.default_value === '' ||
            file_upload.preview_file_src === '');
    };
    /**
     * 「確認」「提出取消」ボタンのdisabled判定
     *
     * @param {FileUploadType} file_upload ファイル用オブジェクト
     * @return {boolean} 判定結果(disabledならtrue)
     */
    var disabedSubmitCancelAndConfirm = function (file_upload) {
        return file_upload.is_loading || !file_upload.is_uploaded || file_upload.confirm_date !== '';
    };
    /**
     * プレビュー画像周りに表示するボタンのdisabled判定
     *
     * @param {FileUploadType} file_upload ファイル用オブジェクト
     * @return {boolean} 判定結果(disabledならtrue)
     */
    var disabledPreview = function (file_upload) {
        return ((!file_upload.is_staff && file_upload.is_uploaded) ||
            (file_upload.is_staff && file_upload.confirm_date !== '') ||
            file_upload.is_loading ||
            file_upload.is_pdf);
    };
    /**
     * 「書類DL」ボタンのdisabled判定
     *
     * @param {FileUploadType} file_upload ファイル用オブジェクト
     * @return {boolean} 判定結果(disabledならtrue)
     */
    var disabedFileDownload = function (file_upload) {
        return file_upload.is_loading || !file_upload.is_uploaded || !file_upload.is_staff;
    };
    /**
     * disabled===falseの時のview
     */
    var viewBlockEnabled = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "document_input_attention", dangerouslySetInnerHTML: { __html: convertLine(files_upload_info.attention) } }),
            files_upload.map(function (file_upload) { return (React.createElement("div", { key: file_upload.name },
                React.createElement(RowTemplate, { label: file_upload.title, content: React.createElement(React.Fragment, null,
                        React.createElement(Row, null,
                            React.createElement(Col, { md: 6 },
                                React.createElement(FileSelect, { file_upload: file_upload, handleChange: function (event) {
                                        return handleFileSelect(file_upload, event);
                                    } }))),
                        file_upload.preview_file_src && (React.createElement("div", null,
                            React.createElement(Canvas, { img_src: file_upload.preview_file_src, disabled: disabledPreview(file_upload), handleFinish: function (file_src) {
                                    startLoading(file_upload, 'マスキング処理中');
                                    handleMaskingFinish(file_src, file_upload);
                                }, block_disabled: block_disabled, file_download: file_upload.file_upload_name, file_name: file_upload.file_label, is_pdf: file_upload.is_pdf }))),
                        React.createElement(Row, null,
                            React.createElement(Col, { md: 4 },
                                "\u72B6\u614B\uFF1A",
                                file_upload.file_status),
                            React.createElement(Col, { md: 6 },
                                "\u63D0\u51FA\u65E5\u6642\uFF1A",
                                file_upload.file_upload_date)),
                        file_upload.is_staff && (React.createElement(Row, null,
                            React.createElement(Col, { md: 4 },
                                "\u78BA\u8A8D\u8005\uFF1A",
                                file_upload.confirm_user),
                            React.createElement(Col, { md: 6 },
                                "\u78BA\u8A8D\u65E5\u6642\uFF1A",
                                file_upload.confirm_date))),
                        React.createElement(Form.Group, null,
                            React.createElement(InputGroup, null,
                                React.createElement("div", { className: "file-name-box" },
                                    React.createElement(Form.File, { className: file_upload.file_label !== null &&
                                            file_upload.file_label.length > file_upload_clamp_config.length &&
                                            !file_upload.is_uploaded
                                            ? 'file-name-long'
                                            : '', label: addClamp(file_upload.file_label, file_upload.is_uploaded) ||
                                            'ファイル選択…', "data-browse": "\u53C2\u7167", custom: true, accept: "image/jpeg,image/png,application/pdf,image/gif,image/bmp,image/heic", onChange: function (event) {
                                            return handleFileInput(file_upload, event);
                                        }, disabled: file_upload.is_loading ||
                                            file_upload.is_uploaded ||
                                            file_upload.default_value === '' })),
                                React.createElement(InputGroup.Append, null,
                                    React.createElement(Button, { className: disabedSubmit(file_upload)
                                            ? 'btn-shadow gradation'
                                            : 'btn-positive gradation', onClick: function () { return compressorImage(file_upload); }, disabled: disabedSubmit(file_upload) }, "\u9280\u884C\u3078\u63D0\u51FA"),
                                    React.createElement(Button, { className: disabedSubmitCancelAndConfirm(file_upload)
                                            ? 'btn-shadow gradation'
                                            : 'btn-confirm-cancel gradation', onClick: function () { return modalControl(file_upload, true); }, disabled: disabedSubmitCancelAndConfirm(file_upload) }, "\u63D0\u51FA\u53D6\u6D88"),
                                    file_upload.is_staff && (React.createElement(React.Fragment, null,
                                        React.createElement(Button, { className: disabedSubmitCancelAndConfirm(file_upload)
                                                ? 'btn-shadow gradation'
                                                : 'btn-positive gradation', onClick: function () { return compressorImage(file_upload); }, disabled: disabedSubmitCancelAndConfirm(file_upload) }, "\u78BA\u8A8D"),
                                        React.createElement(Button, { className: "btn-shadow gradation", onClick: function () { return handleConfirmCancel(file_upload); }, disabled: file_upload.is_loading || file_upload.confirm_date === '' }, "\u78BA\u8A8D\u53D6\u6D88")))),
                                React.createElement("div", { className: "ml-2" }),
                                file_upload.is_staff && (React.createElement(Button, { className: disabedFileDownload(file_upload)
                                        ? 'round-btn btn-shadow gradation'
                                        : 'round-btn btn-positive gradation', onClick: function () { return handlefileDownLoad(file_upload.file_upload_name); }, disabled: disabedFileDownload(file_upload) }, "\u66F8\u985EDL")),
                                file_upload.is_add && (React.createElement(Button, { className: "btn-shadow gradation", onClick: function () { return handleAdd(file_upload); }, disabled: file_upload.is_loading || is_processing }, "\u66F8\u985E\u8FFD\u52A0")),
                                !file_upload.is_add && (React.createElement(Button, { className: "btn-shadow gradation", onClick: function () { return handleDelete(file_upload); }, disabled: file_upload.is_loading || file_upload.is_uploaded || is_processing }, "\u63D0\u51FA\u6B04\u524A\u9664"))),
                            React.createElement("div", null, Object.keys(file_upload.valid_messages).includes('file') && (React.createElement(ValidMessage, { message: file_upload.valid_messages.file }))),
                            React.createElement("div", null,
                                file_upload.is_loading && (React.createElement("div", { className: "spinner-border", role: "status" })),
                                file_upload.loading_msg && React.createElement("span", null, file_upload.loading_msg)))) }),
                React.createElement(ModalTemplate, { key: file_upload.name, show: file_upload.is_modal_show, title: "\u524A\u9664\u306E\u78BA\u8A8D", body: React.createElement("div", null, "\u63D0\u51FA\u6E08\u307F\u306E\u30D5\u30A1\u30A4\u30EB\u3092\u524A\u9664\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3057\u3087\u3046\u304B"), ClickCallBackNo: function () {
                        modalControl(file_upload, false);
                    }, ClickCallBackYes: function () { return handleCancel(file_upload); }, t: t }))); }),
            React.createElement(ValidMessage, { message: file_upload_message }),
            React.createElement(NextButton, { label: "\u6B21\u3078", strong: false, handleClick: handleNextButtonClick, disabled: next_button_disabled, show: !next_button_disabled })));
    };
    /**
     * disabled===trueの時のview
     */
    var viewBlockDisabled = function () {
        return (React.createElement(React.Fragment, null,
            files_upload.map(function (file_upload) { return (React.createElement("div", { key: file_upload.name },
                React.createElement(RowTemplate, { label: file_upload.title, content: React.createElement(React.Fragment, null,
                        React.createElement(Row, null,
                            React.createElement(Col, { md: 4 }, file_upload.source.map(function (src) {
                                if (src.key === file_upload.default_value) {
                                    return src.value;
                                }
                            }))),
                        React.createElement(Form.Group, null, file_upload.preview_file_src && (React.createElement("div", null,
                            React.createElement(Canvas, { img_src: file_upload.preview_file_src, disabled: file_upload.is_uploaded, handleFinish: function (file_src) {
                                    handleMaskingFinish(file_src, file_upload);
                                }, block_disabled: block_disabled, file_download: file_upload.file_upload_name, file_name: file_upload.file_label, is_pdf: file_upload.is_pdf })))),
                        React.createElement(Row, null,
                            React.createElement(Col, { md: 4 },
                                "\u72B6\u614B\uFF1A",
                                file_upload.file_status),
                            React.createElement(Col, { md: 6 },
                                "\u63D0\u51FA\u65E5\u6642\uFF1A",
                                file_upload.file_upload_date)),
                        file_upload.is_staff && (React.createElement(Row, null,
                            React.createElement(Col, { md: 4 },
                                "\u78BA\u8A8D\u8005\uFF1A",
                                file_upload.confirm_user),
                            React.createElement(Col, { md: 6 },
                                "\u78BA\u8A8D\u65E5\u6642\uFF1A",
                                file_upload.confirm_date))),
                        file_upload.is_staff && !disabedFileDownload(file_upload) && (React.createElement(Button, { className: disabedFileDownload(file_upload)
                                ? 'round-btn btn-shadow gradation'
                                : 'round-btn btn-positive gradation', onClick: function () { return handlefileDownLoad(file_upload.file_upload_name); }, disabled: disabedFileDownload(file_upload) }, "\u66F8\u985EDL"))) }))); }),
            React.createElement(NextButton, { label: "\u6B21\u3078", strong: false, handleClick: handleNextButtonClick, disabled: next_button_disabled, show: next_button_disabled })));
    };
    return (React.createElement(React.Fragment, null,
        !block_disabled ? viewBlockEnabled() : viewBlockDisabled(),
        React.createElement(LoadingModal, { show: is_loading })));
};
export default memo(FileUpload);
